<template>
    <el-popover 
        :key="`component-select-pop-${randomId}`"
        v-model="showList"
        placement="bottom-start"
        trigger="manual"
        popper-class="component-select-group-pop" 
        @after-leave="$emit('after-leave')"
    >
        <!-- 显示的文本框 -->
        <div
            slot="reference" 
            :key="`reference-${randomId}`"
            :style="{width: componentWidth + 'px'}" 
            :title="selectedLabel"
            :class="{
                'component-select-group-label': true,
                'component-select-group-label-disable':disabled,
                'is-selected':showList
            }"
            @click.stop="showFilterList($event)"
            @mouseover="onMouseoverLabel"
            @mouseout="onMouseoutLabel"
        >
            {{ selectedLabel || placeholder }}

            <div
                v-if="!showClear"
                :class="arrowClasses"
            />

            <div
                v-if="showClear"
                class="el-icon-circle-close component-select-group-label-clear"
                @click="clearData" 
            />
        </div>

        <!-- 下拉列表 -->
        <div 
            :style="{minWidth: componentWidth + 'px'}"         
            class="select-list-container"
        >
            <!-- 数据列表 -->
            <div
                v-for="(item,index) in dataList"
                :key="index"
                class="list-item group-item"
            >
                <!-- 分组的数据列表 -->
                <div
                    class="select-item parent-node"
                    @click.stop="selectParentItem(item)"
                >
                    <span :class="{'el-checkbox__input': true, 'is-checked': item.checked, 'is-indeterminate': item.indeterminate }">
                        <span class="el-checkbox__inner" />
                        <input 
                            :checked="item.checked" 
                            class="el-checkbox__original" 
                            type="checkbox"
                        >
                    </span>

                    <label class="select-item-label">{{ item.label }}</label>
                </div>

                <!-- 分组的各组的数据列表 -->
                <template v-for="child in item.options">
                    <div                    
                        v-if="item.options"
                        :key="child.value"
                        class="select-item child-item"
                        @click.stop="selectItem(child,item)"
                    >
                        <span :class="{'el-checkbox__input': 'true', 'is-checked':child.checked}">
                            <span class="el-checkbox__inner" />
                            <input 
                                :checked="child.checked" 
                                class="el-checkbox__original" 
                                type="checkbox"
                            >
                        </span>

                        <label class="select-item-label">{{ child.label }}</label>
                    </div>
                </template>
            </div>
        </div>
    </el-popover>   
</template>

<script>
export default {
  name: "SelectGroupCustom",  
  
  inheritAttrs: false,

  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },

    /** 是否禁用 */
    disabled: {
      type: Boolean,
      default: false
    },

    options: {
      type: Array,
      default() {
        return [];
      }
    },

    /** 最大可选数 */
    maxSelect: {
      type: [Number],
      default: 100000
    },

    /** 在数据对象中对应的键，用于唯一标识数据 */
    dataKey: {
      type: String,
      default: "value"
    },

    /** 总宽度 */
    width: {
      type: [String, Number],
      default: "220"
    },

    /** 是否要删除按钮 */
    clearable: {
      type: Boolean,
      default: true
    },

    /** 默认的文字 */
    placeholder: {
      type: String,
      default: "请选择"
    },

    /** 全选状态下，显示的文字，如果文字判定为Flase，则显示所有选中的项的label */
    checkedAllLabel: {
      type: String,
      default: "全选"
    },

    /** 返回的结果的key */
    resultKey: {
      type: String,
      default: "value"
    }
  },

  data() {
    return {
      randomId: Math.random()
        .toString()
        .replace(".", ""),
      /** 控制是否显示清空按钮 */
      showClear: false,
      dataList: [],
      /** 已选中的数据 */
      selectedData: [],
      /** 已选项的文字内容 */
      selectedLabel: "",
      /** 是否显示下拉列表 */
      showList: false
    };
  },

  computed: {
    componentWidth() {
      return (this.width + "").replace(/px/, "");
    },

    arrowClasses() {
      return {
        "select-arrow": true,
        "component-select-group-label-arrow": true,
        "component-select-group-label-arrow-reverse": this.showList
      };
    }
  },

  watch: {
    value(val) {
      if (!val || (this.options && !this.options.length)) return;

      this.handleData(this.dataList);
      this.setSelectedLabel();
    },

    options: {      
      immediate: true,
      handler(val) {
        if (val) {
          this.handleData(val);
          this.setSelectedLabel();
        }
      }
    }
  },

  mounted() {
    document.addEventListener("click", this.clickDoc);
  },

  beforeDestroyed() {
    document.removeEventListener("click", this.clickDoc);
  },

  methods: {
    handleData(data) {
      let temp = JSON.parse(JSON.stringify(data));

      this.dataList = temp.map(item => {
        item.checked = this.value.includes(item.value);

        if (item.options) {
          let checkedCount = 0;
          let checkedAll = true;

          item.options.forEach(child => {
            child.checked = this.value.includes(child.value);

            if (!child.checked) {
              checkedAll = false;
            }
            else {
              checkedCount++;
            }
          });

          item.checked = !!(checkedAll && checkedCount);
          item.indeterminate = !!(!checkedAll && checkedCount);
        }

        return item;
      });
    },

    showFilterList(e) {
      if (this.disabled) return;

      e.stopPropagation();

      this.showList = !this.showList;
    },

    clearData() {
      this.dataList.forEach(item => {
        item.checked = false;
        item.indeterminate = false;

        if (item.options) {
          item.options.forEach(child => {
            child.checked = false;
          });
        }
      });

      this.selectedLabel = this.placeholder;

      this.$emit("input", []);
    },

    reset() {
      this.dataList.forEach(item => {
        item.checked = true;
        item.indeterminate = false;

        if (item.options) {
          item.options.forEach(child => {
            child.checked = true;
          });
        }
      });

      this.setSelectedLabel();

      this.showList = false;
    },

    clickDoc(e) {
      if (!this.$el.contains(e.target)) {
        this.showList = false;
      }
    },

    onMouseoverLabel() {
      if (this.disabled) return;

      this.showClear = false;
      // this.showClear = this.clearable && this.selectedData.length;
    },

    onMouseoutLabel() {
      this.showClear = false;
    },

    setSelectedLabel() {
      let checkedItems = [];
      let checkedAll = true;
      let checkedCount = 0;

      this.dataList.forEach(item => {
        if (item.options) {
          item.options.forEach(child => {
            if (child.checked) {
              checkedItems.push(child);
              checkedCount++;
            }
            else {
              checkedAll = false;
            }
          });
        } else {
          if (item.checked) {
            checkedItems.push(item);
            checkedCount++;
          }
          else {
            checkedAll = false;
          }
        }
      });

      // 如果全部未选中
      if (!checkedCount) {
        this.selectedLabel = this.placeholder;
      } else {
        this.selectedLabel = checkedAll 
          ? this.checkedAllLabel 
          : checkedItems.reduce((prev,next) => { 
            prev += ";" + next.label ; 

            return prev ;
          },"").slice(1);
      }
    },

    /**
     * 获取结果数据
     */
    getValue() {
      let result = [];

      this.dataList.forEach(item => {
        if (item.options) {
          item.options.forEach(child => {
            if (child.checked) {
              result.push(child[this.resultKey]);
            }
          });
        } 
        else {
          if (item.checked) {
            result.push(item[this.resultKey]);
          }
        }
      });

      this.$emit("input", result);
    },

    /**
     * 点击列表时触发的事件
     */
    clickList(e) {
      e.stopPropagation();
    },

    /**
     * 选中某一项时触发的事件
     * @param {Object} item
     * @param {Object} parent 该选项的父选项
     */
    selectItem(item, parent) {
      item.checked = !item.checked;

      this.setParentState(parent);
      this.getValue();
      this.setSelectedLabel();
    },

    /**
     * 设置父节点状态
     * @param {Object} parent
     */
    setParentState(parent) {
      let checkedAll = true;
      let checkedCount = 0;

      parent.options.forEach(item => {
        if (item.checked) {
          checkedCount++;
        }
        else {
          checkedAll = false;
        }
      });

      parent.checked = !!(checkedAll && checkedCount);
      parent.indeterminate = !!(!checkedAll && checkedCount);
    },

    /**
     * 选中了父选项
     * @param {Object} parent
     */
    selectParentItem(parent) {
      parent.checked = !parent.checked;
      parent.indeterminate = false;

      if (parent.options) {
        parent.options.forEach(item => {
          item.checked = parent.checked;
        });
      }

      this.dataList = [...this.dataList];

      this.getValue();
      this.setSelectedLabel();
    }
  }
};
</script>

<style lang="scss">
.component-select-group {
  &-label {
    width: 160px;
    display: inline-block;
    padding: 0 22px 0 12px; 
    border: 1px solid #D4D6DF;
    height: 30px;
    line-height: 28px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    cursor: pointer;
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    color: #666;
    outline: none;

    &.is-selected{
      border-color: #8EACE8 !important;
    }

    &-disable {
      background-color: #f5f7fa !important;
      color: #c0c4cc !important;
      cursor: not-allowed !important;
      opacity: .75 !important; // border-color: #ebeef5 !important;
    }

    .select-arrow{
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid;
      border-top-color: #D4D6DF;
      top: 14px;
      right: 8px;
    }

    &-arrow {
      position: absolute;
      top: 8px;
      right: 6px;
      color: #666;
      transition: transform .3s;
      transform: rotate(0deg);
      &-reverse {
        transform: rotate(180deg);
      }
    }
  }

  &-pop {
    margin-top: 8px;
    padding: 5px 0;
    width: auto;

    .select-list-container {
      max-height: 280px;
      overflow: auto;
    }

    .select-item {
      padding: 8px 10px;
      max-width: 380px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      background-color: #fff;
      white-space: nowrap;
      cursor: pointer;

      &:hover {
        background-color: #e4e8f1;
      }
    }

    .child-item {
      padding-left: 30px;
    }

    .group-item {
      border-bottom: 1px solid #e8e8e8;
    }

    .parent-node {
      font-weight: 600
    }

    .select-item-label {
      margin-left: 6px;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>

